import React from 'react';
import { useSelector } from 'react-redux';
import InputField from "@src/common/InputField"
import LeadRemarksButton from '../common/LeadRemarksButton';
import { COND_SHOW_FIELDS_ACC_INSURERS, COUNTRY_CODE, FEATURE_LISTING, INS_TYPE_CTPL,VEHICLE_TYPE_MOTORCYCLE,VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL } from '@src/config/constant';
import ReactSelect from '@common/ReactSelect';
import { useLanguage } from '@src/context/LanguageContext';

const isCountryId = COUNTRY_CODE === 'id'?true:false

export default function LoanExpectedRightPanel(props: any): ReturnType<React.FC> {
    const commonState = useSelector((state: any) => state.insurance);
    const stateCommon = useSelector((state: any) => state.common);
    const {translations} = useLanguage();    

    let { make_name, model_name, version_name, make_year, tenure, car_fmv, color, plate_number, machine_number, chassis_number,
        vehicle_seat, fuel_type, transmission, vehicle_type, mv_number, insurance_type_id, vehicle_usage, plate_area, vehicle_type_id,
        engine_capacity, parent_model_name, master_type, insurer_id, vehicle_category
    } = commonState && commonState?.leadDetail


    let disable = true;

    let fieldMapping: any = {
        PLATE_AREA: (
            <fieldset className="col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "plate_area",
                            name: "plate_area",
                            className: "form-input",
                            type: "text",
                            value: stateCommon?.common?.plate_area?.find((v: any) => Number(plate_area) === +v.value)?.label || '',
                            maxLength: '',
                            disabled: disable,
                            placeholder: " "
                        }}
                    />
                    <label data-label= {`${translations.Insurance?.['Plate Area'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                </div>
            </fieldset>
        ),

        PLATE_NUMBER_REGION: (
            <fieldset className="col-md-6">
                <div className="material" title={stateCommon?.common?.plate_area?.find((v: any) => Number(plate_area) === +v.value)?.region || ''}>
                    <InputField
                        inputProps={{
                            id: "plate_number_region",
                            name: "plate_number_region",
                            className: "form-input",
                            type: "text",
                            value: stateCommon?.common?.plate_area?.find((v: any) => Number(plate_area) === +v.value)?.region || '', 
                            maxLength: '',
                            disabled: disable,
                            placeholder: " "
                        }}
                    // onChange={(e: any) => changeHandler(e, 'plate_number_region')}
                    />
                    <label data-label= {`${translations.Insurance?.['Plate Number Region'] || translations.commonMsg?.loading} *`}className="form-label"></label>
                </div>
            </fieldset>
        ),
        MAKE: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "Make",
                            name: "Make",
                            className: "form-input",
                            type: "text",
                            value: make_name || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['Make'] || translations.commonMsg?.loading}`}className="form-label"></label>
                </div>
            </fieldset>
        ),
        MODEL: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "Model",
                            name: "Model",
                            className: "form-input",
                            type: "text",
                            value: COUNTRY_CODE ==='id' ? parent_model_name : model_name || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['Model'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),
        VERSION: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "Variant",
                            name: "Variant",
                            className: "form-input",
                            type: "text",
                            value: version_name || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label= {`${translations.Insurance?.['Variant'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),
        ENGINE_CAPACITY: (
            ([VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(vehicle_type_id) || isCountryId) && <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField 
                        inputProps={{
                            id:"engine_capacity",
                            name:"engine_capacity",
                            className:"form-input",
                            type:"text",
                            value: (isCountryId)? (engine_capacity === "" || engine_capacity === undefined || engine_capacity === null) ? "" : engine_capacity: stateCommon?.common?.engine_capacity?.find((el:any)=> +el.value === +engine_capacity)?.label || '',
                            maxLength:'',
                            disabled:disable
                        }} 
                        onChange={''}
                    />
                    <label data-label={`${(isCountryId)?translations.Insurance?.['CUBIC_CAP']:translations.Insurance?.['ENGINE_CAP'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),
        MAKE_YEAR: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "mfg_year",
                            name: "mfg_year",
                            className: "form-input",
                            type: "text",
                            value: make_year || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label= {`${translations.Insurance?.['Manufacturing Year'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),
        VEHICLE_USAGE: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "vehicle_usage",
                            name: "vehicle_usage",
                            className: "form-input",
                            type: "text",
                            value: vehicle_usage || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label= {`${translations.Insurance?.['Vehicle Usage'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),
        TENURE: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "tenure",
                            name: "tenure",
                            className: "form-input",
                            type: "text",
                            value: tenure || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['Tenure(In Year)'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),
        VEHICLE_CATEGORY: (
             <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "vehicle_category",
                            name: "vehicle_category",
                            className: "form-input",
                            type: "text",
                            value: stateCommon?.common?.vehicle_category?.find((v: any) => Number(vehicle_category) === +v.value)?.label || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label= {`${translations.Insurance?.['VEHICLE_CATEGORY'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),

        VEHICLE_TYPE: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "vehicle_type",
                            name: "vehicle_type",
                            className: "form-input",
                            type: "text",
                            value: props.vehicleTypeList.filter((ob: any) => ob.value === vehicle_type)?.[0]?.['label'],
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label= {`${translations.Insurance?.['Vehicle Type'] || translations.commonMsg?.loading}`}className="form-label"></label>
                </div>
            </fieldset>
        ),
        CAR_FMV: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "fmv_car",
                            name: "fmv_car",
                            className: "form-input",
                            type: "text",
                            value: car_fmv || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['FMV'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),
        COLOR: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "color",
                            name: "color",
                            className: "form-input",
                            type: "text",
                            value: color || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['Color'] || translations.commonMsg?.loading}`}className="form-label"></label>
                </div>
            </fieldset>
        ),

        PLATE_NUMBER: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "plate_no",
                            name: "plate_no",
                            className: "form-input",
                            type: "text",
                            value: plate_number || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label= {`${translations.Insurance?.['Plate Number'] || translations.commonMsg?.loading}`}className="form-label"></label>
                </div>
            </fieldset>
        ),
        MV_NUMBER: (
            (insurance_type_id === INS_TYPE_CTPL && mv_number) && <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "mv_number",
                            name: "mv_number",
                            className: "form-input",
                            type: "text",
                            value: mv_number || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label= {`${translations.Insurance?.['MV File Number'] || translations.commonMsg?.loading}`}className="form-label"></label>
                </div>
            </fieldset>
        ),

        MACHINE_NUMBER: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "machine_number",
                            name: "machine_number",
                            className: "form-input",
                            type: "text",
                            value: machine_number || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['Engine Number'] || translations.commonMsg?.loading}`}className="form-label"></label>
                </div>
            </fieldset>
        ),
        CHASSIS_NUMBER: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "chassis_number",
                            name: "chassis_number",
                            className: "form-input",
                            type: "text",
                            value: chassis_number || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['Chassis Number'] || translations.commonMsg?.loading}`}className="form-label"></label>
                </div>
            </fieldset>
        ),
        SEATING_CAPACITY: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "seat_capacity",
                            name: "seat_capacity",
                            className: "form-input",
                            type: "text",
                            value: vehicle_seat || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['Seating Capacity'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),
        FUEL_TYPE: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "fuel_type",
                            name: "fuel_type",
                            className: "form-input",
                            type: "text",
                            value: fuel_type || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['Fuel'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        ),
        TRANSMISSION: (
            <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "transmission",
                            name: "transmission",
                            className: "form-input",
                            type: "text",
                            value: transmission || '',
                            maxLength: '',
                            disabled: disable
                        }}
                        onChange={''}
                    />
                    <label data-label={`${translations.Insurance?.['Transmission'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        )
    }

    const conditionalFieldMapping: any = {
        MASTER_TYPE: (
             <fieldset className="form-filed col-md-6">
                <div className="material">
                    <InputField
                        inputProps={{
                            id: "master_type",
                            name: "master_type",
                            className: "form-input",
                            type: "text",
                            value: master_type || '',
                            maxLength: '',
                            disabled: disable
                        }}
                    />
                    <label data-label={`${translations.Insurance?.['MASTER_TYPE'] || translations.commonMsg?.loading}`} className="form-label"></label>
                </div>
            </fieldset>
        )
    }

    if (insurer_id && COND_SHOW_FIELDS_ACC_INSURERS.includes(insurer_id)
    ) {
        fieldMapping = {
            ...fieldMapping,
            ...conditionalFieldMapping
        }
    }
   

    let visibleFields = Object.keys(fieldMapping)?.filter((field: any) => FEATURE_LISTING['LEAD_DETAILS']['QUOTE_DETAILS']['VEHICLE_DETAILS'][field])

    
    return (
        <div className="loan-form">


            <div className="form-group-bx">
                <h2>{translations.Insurance?.['Vehicle Details'] || translations.commonMsg?.loading}</h2>
                <div className="row">
                    {
                        visibleFields?.map((field: any) => {
                            return <React.Fragment key={field}>
                                {fieldMapping[field]}
                            </React.Fragment>
                        })
                    }
                </div>
            </div>


            {commonState?.leadDetail?.leadId && <LeadRemarksButton leadId={commonState.leadDetail.leadId} />}


        </div>


    )
}
